export type MemoizeOptions<Args extends unknown[]> = {
    timeout?: number;
    cacheKeyFactory?: (...args: Args) => string;
    debug?: boolean;
};

export function memoize<Args extends unknown[], Result>(
    fn: (...args: Args) => Result,
    options?: MemoizeOptions<Args>
): (...args: Args) => Result {
    const cache = new Map<string, { value: Result }>();
    const cacheKeyFactory: (...args: Args) => string = options?.cacheKeyFactory ?? ((...args) => btoa(args[0] as string));
    const debug = options?.debug ?? false;

    return (...args) => {
        const key = args.length > 0
            ? cacheKeyFactory(...args)
            : 'A';
        const cached = cache.get(key);

        if (cached !== undefined) {
            if (debug) {
                // eslint-disable-next-line no-console
                console.log(key, 'memoize cache hit');
            }
            return cached.value;
        }

        if (debug) {
            // eslint-disable-next-line no-console
            console.log(key, 'memoize not cached');
        }
        const result = fn(...args);
        cache.set(key, { value: result });

        if (options?.timeout) {
            setTimeout(() => {
                if (cache.has(key)) {
                    if (debug) {
                        // eslint-disable-next-line no-console
                        console.log(key, 'memoize deleting cache');
                    }
                    cache.delete(key);
                }
            }, options.timeout);
        }

        return result;
    };
}
